import { create } from 'zustand';
import { Motivator } from '../types';

interface PlayerRanking {
  playerName: string;
  email: string;
  ranking: string[];
}

interface RoomInfo {
  id: string;
  roomName: string;
  visibility: 'public' | 'private';
  createdBy: string; // email of creator
  currentUserEmail: string;
}

interface MovingMotivatorsStore {
  motivators: Motivator[];
  ranking: string[];
  roomInfo: RoomInfo | null;
  participants: PlayerRanking[];
  setRanking: (ranking: string[]) => void;
  resetRanking: () => void;
  initializeMotivators: (motivators: Motivator[]) => void;
  setRoomInfo: (roomInfo: RoomInfo) => void;
  setParticipants: (participants: PlayerRanking[]) => void;
}

const defaultMotivatorIds = [
  'curiosity',
  'honor',
  'acceptance',
  'mastery',
  'power',
  'freedom',
  'relatedness',
  'order',
  'goal',
  'status',
];

export const useMovingMotivatorsStore = create<MovingMotivatorsStore>((set) => ({
  motivators: [],
  ranking: defaultMotivatorIds,
  roomInfo: null,
  participants: [],
  
  setRanking: (ranking) => set({ ranking }),
  
  resetRanking: () => set({ ranking: defaultMotivatorIds }),
  
  initializeMotivators: (motivators) => set({ motivators }),
  
  setRoomInfo: (roomInfo) => set({ roomInfo }),
  
  setParticipants: (participants) => set({ participants }),
}));
